import axios from 'axios';

export default {
    methods: {
        async costoIndex(d, ok, err) {
            try {
                let r = await axios.get('costo?page=' + d.page, {params: d});
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async costoGenerar(ok, err) {
            try {
                let r = await axios.post('costo/generar');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async costoDatos(ok, err) {
            try {
                let r = await axios.post('costo/datos');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async costoUpdate(id, d, ok, err) {
            try {
                let r = await axios.put('costo/' + id, d);
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/costo.js